import React from 'react';

import { MedicalRecordsDashboard } from '@/components/medical-records-dashboard';
import { useDocumentTitle } from '@/contexts/DocumentTitleContext';

export const MedicalRecordsDashboardPage: React.FC = () => {
  const { setTitle } = useDocumentTitle();
  React.useEffect(() => {
    setTitle('Medical Records Dashboard');
  }, [setTitle]);

  return <MedicalRecordsDashboard />;
};

export default MedicalRecordsDashboardPage;
